<app-auth-modal-shell *ngIf="isVisible" title="Reset password" (closed)="onOverlayClickReset()">
  <form class="reset-password-modal__form" [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit()">
    <app-auth-email-field [control]="resetPasswordForm.controls.email" />

    <app-button variant="main" size="lg" [disabled]="isFormInvalid" [fullWidth]="true">
      <span *ngIf="isLoading" class="app-spinner app-spinner--on-inverse"></span>
      <span *ngIf="!isLoading">SEND</span>
    </app-button>

    <p class="reset-password-modal__register-text">
      Back to
      <a href="#" class="reset-password-modal__register-link" (click)="openSignIn(); $event.preventDefault()">LogIn</a>
    </p>

    <div *ngIf="!!errorMessage" class="reset-password-modal__error-message-text">
      {{ errorMessage }}
    </div>
  </form>
</app-auth-modal-shell>

<app-confirm-dialog
  [visible]="isSuccessModalVisible"
  [title]="'Password reset email sent'"
  [showButtons]="false"
  iconSrc="../../../assets/icons/checkmark-ok.svg"
  [description]="'We’ve sent you an email with a link to reset your password. Please check your inbox.'"
  (confirm)="closeModal()"
  (cancel)="closeModal()"
></app-confirm-dialog>
